import React from 'react';
import coverbackground from '../../assets/coralb.jpg';
import ReusableMetricCard from '../../components/ReusableMetriccard/ReusableMetriccard';
import Dn from '../../assets/dn.png';

class ScrollCoral extends React.Component {
  render () { 
   return(
  
  <ReusableMetricCard             
    
        
        description="Coral Reefs"
        trend={Dn}
        metriclg="32% at risk"
        metricsm="of loss by 2050"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollCoral;